function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgMenuDashboard = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "3.022 3.962 18.795 16.141",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
  d: "M 4.918 20.051 L 21.39 20.051 C 21.65 20.051 21.852 19.84 21.852 19.587 C 21.852 19.324 21.641 19.123 21.39 19.123 L 21.138 19.123 L 21.138 16.408 C 21.138 15.919 20.744 15.522 20.256 15.522 L 18.218 15.522 C 17.731 15.522 17.337 15.919 17.337 16.408 L 17.337 19.123 L 15.398 19.123 L 15.398 14.358 C 15.398 13.811 14.954 13.363 14.408 13.363 L 12.588 13.363 C 12.043 13.363 11.598 13.811 11.598 14.358 L 11.598 19.123 L 9.675 19.123 L 9.675 10.952 C 9.675 10.302 9.147 9.762 8.501 9.762 L 7.066 9.762 C 6.412 9.762 5.884 10.295 5.884 10.952 L 5.884 19.123 L 4.918 19.123 C 4.381 19.123 3.953 18.685 3.953 18.154 L 3.953 9.754 C 3.953 9.501 3.743 9.291 3.484 9.291 C 3.223 9.291 3.022 9.501 3.022 9.754 L 3.022 18.145 C 3.022 19.199 3.869 20.051 4.918 20.051 Z M 6.814 19.123 L 6.814 10.698 L 8.753 10.698 L 8.753 19.123 L 6.814 19.123 Z M 12.546 19.123 L 12.546 14.3 L 14.483 14.3 L 14.483 19.123 L 12.546 19.123 Z M 18.268 19.123 L 18.268 16.458 L 20.206 16.458 L 20.206 19.123 L 18.268 19.123 Z",
  fill: "#646464",
  style: {}
}));

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMenuDashboard, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/menu-dashboard.7cc3ce99.svg";
export { ForwardRef as ReactComponent };